import React, { useState, useEffect, useRef } from 'react';
import './nextgpt.scss';
import botProfileIcon from '../../../images/people/botprofileicon.svg';
import smList from '../../../mocks/profiles/smList.json';
import messageLoadingGif from '../../../images/messageloading.gif';

function Assistant(props) {
    let accumulatedData = '';
    let remainedData = null;

    const { content, messages, setMessages, resetContent } = props;
    const [smImage, setSmImage] = useState(botProfileIcon);
    const [selectedSM] = useState(localStorage.getItem('SM') || 'Jackson Lim');
    const chatbotResponseIndexRef = useRef(null);
    const bottomRef = useRef(null);

    useEffect(() => {
        const selectedSMProfile = smList.profile.find(profile => profile.name === selectedSM);
        if (selectedSMProfile) {
            setSmImage(selectedSMProfile.image);
        }
    }, [selectedSM]);

    useEffect(() => {
        const callNextGpt = async (usecase, file, content) => {
            const formData = new FormData();
            const blob = await fetch(file);
            const data = await blob.blob();
            const accessToken = 'vehzcryR9jKk6ImttBLXQHS_dQn0etD5kdM-yeBQots';
            const apiUrl = 'https://nextgpt.southeastasia.cloudapp.azure.com/_api/api/v1/models/' + usecase + '/session';
    
            
            const transcriptUsed = localStorage.getItem('transcript');
            if (transcriptUsed === 'mixed')
                formData.append('transcript', new File([data], "/bank_rm_transcript_mixed.txt"));
            else 
                formData.append('transcript', new File([data], "/bank_rm_transcript.txt"));

            const callChatbot = async (session_id, usecase, user, content) => {
                const accessToken = 'vehzcryR9jKk6ImttBLXQHS_dQn0etD5kdM-yeBQots';
                const apiUrl = 'https://nextgpt.southeastasia.cloudapp.azure.com/_api/api/v1/chat/completions?debug=false&session_id=' + session_id;
        
                const stream = new ReadableStream({
                    start(controller) {
                        const processResponse = async (response, controller) => {
                            const reader = response.body.getReader();
                            let { done, value } = await reader.read();
                            while (!done) {
                                processChunk(new TextDecoder().decode(value), controller);
                                ({ done, value } = await reader.read());
                            }
                        };
        
                        fetch(apiUrl, {
                            method: 'POST',
                            headers: {
                                'Authorization': `Bearer ${accessToken}`,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                "model": usecase,
                                "messages": [
                                    {
                                        "role": user,
                                        "content": content
                                    }
                                ],
                                "max_tokens": 1000,
                                "temperature": 0,
                                "stream": true
                            })
                        })
                            .then(response => processResponse(response, controller))
                            .catch(error => console.error('Error fetching data:', error));
                    }
                });
            };
            fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
                body: formData
            })
                .then(response => response.text())
                .then(data => {
                    callChatbot(data, usecase, "user", content);
                })
                .catch(error => {
                    console.error('There was a problem with your fetch operation:', error);
                });
        };
    
        if (content === "") {
            console.log("no content");
        } else {
            const delayAssistantMessage = () => {
                setMessages((prevMessages) => {
                    chatbotResponseIndexRef.current = prevMessages.length;
                    return [...prevMessages, { role: "assistant", content: "" }];
                });
                const transcriptUsed = localStorage.getItem('transcript');
                if (transcriptUsed === 'mixed')
                    callNextGpt("Bank_Chatbot API", "/bank_rm_transcript_mixed.txt", content);
                else 
                    callNextGpt("Bank_Chatbot API", "/bank_rm_transcript.txt", content);
            };

            setTimeout(delayAssistantMessage, 2000); // Delay for 2 seconds
        }
        resetContent();
    }, [content]);

    useEffect(() => { // to scroll down when generating
        if (messages.length > 0 && messages[messages.length - 1].role === 'assistant') {
            if (bottomRef.current) {
                bottomRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [messages]);

    
    

    const processChunk = (chunk, controller) => {
        chunk = remainedData + chunk;
        var chunkArray = chunk.split('\n');
        chunkArray.forEach((item, index) => {
            if (item.includes('choices')) {
                const jsonData = item.split('data: ')[1];
                try {
                    const data = JSON.parse(jsonData);
                    if (data.choices.length > 0) {
                        const newContent = data.choices[0].delta.content;
                        if (undefined !== newContent) {
                            accumulatedData += newContent;
                            setMessages((prevMessages) => {
                                const newMessages = [...prevMessages];
                                newMessages[chatbotResponseIndexRef.current] = { role: "assistant", content: accumulatedData };
                                return newMessages;
                            });
                        }

                        if (data.choices[0].finish_reason === "stop") {
                            return;
                        }
                    }
                } catch (e) {
                    if (e === "[DONE]") {
                        controller.close();
                        return;
                    }
                }
            } else {
                remainedData = item;
            }
        });
    };

    return (
        <div>
            {messages.map((message, index) => (
                <div key={index} className={`message ${message.role}`}>
                    <img src={message.role === 'user' ? smImage : botProfileIcon} alt="Profile Pic" />
                    {message.role === 'user' ? (
                        <span>{message.content}</span>
                    ) : (
                        <div className='botmessage'>
                            <span>{message.content}</span>
                            <img className={message.content ? 'hide' : ''} src={messageLoadingGif} alt='loading' />
                        </div>
                    )}
                </div>
            ))}
            <div ref={bottomRef}></div>
        </div>
    );
}

export default Assistant;
